type LenisScrollControl = {
  stop: () => void;
  start: () => void;
  on?: (event: 'scroll', callback: () => void) => void;
  off?: (event: 'scroll', callback: () => void) => void;
};

type LenisReadyCallback = () => void;

let activeInstance: LenisScrollControl | null = null;
const readyListeners = new Set<LenisReadyCallback>();

function notifyPerformanceLabLenisReady() {
  readyListeners.forEach((callback) => callback());
}

export function registerPerformanceLabLenis(instance: LenisScrollControl) {
  activeInstance = instance;
  notifyPerformanceLabLenisReady();
}

export function getPerformanceLabLenis() {
  return activeInstance;
}

export function subscribePerformanceLabLenisReady(callback: LenisReadyCallback) {
  if (activeInstance) {
    callback();
  }
  readyListeners.add(callback);
  return () => {
    readyListeners.delete(callback);
  };
}

export function unregisterPerformanceLabLenis(instance: LenisScrollControl) {
  if (activeInstance === instance) activeInstance = null;
}

export function pausePerformanceLabLenisScroll() {
  activeInstance?.stop();
}

export function resumePerformanceLabLenisScroll() {
  activeInstance?.start();
}
